import { ORGANIZATION_STORAGE_KEY } from "@components/constants"

import authorize, { commonRequest, authorizedRequest, authenticatedRequest } from "./authorize"
import authenticate from "./authenticate"

const ERROR_UNAUTHORIZED = "UnauthorizedError"


const useRequest = (setIdentity, onUnexpectedError, onAuthorizationError, authorizationMethod, authentication) => {
  if (!authentication) {
    return (operation, parameters, expectedErrors = []) =>
      commonRequest(onUnexpectedError, operation, parameters, expectedErrors)
  }

  return (operation, parameters, expectedErrors = []) =>
    authorizedRequest(onUnexpectedError, operation, parameters, [...expectedErrors, ERROR_UNAUTHORIZED])
      .catch(error => {
        const isAuthorizationExpired = error.code === ERROR_UNAUTHORIZED

        if (!isAuthorizationExpired) {
          throw error
        }

        const organizationId = sessionStorage.getItem(ORGANIZATION_STORAGE_KEY)

        return authorize(setIdentity, onAuthorizationError, authorizationMethod, authentication, organizationId)
          .then(() => authorizedRequest(onUnexpectedError, operation, parameters, expectedErrors))
      })
}

export const useAuthenticatedRequest = (isBackstage, onUnexpectedError) => {
  return (operation, parameters, expectedErrors = []) =>
    authenticatedRequest(onUnexpectedError, operation, parameters, [...expectedErrors, ERROR_UNAUTHORIZED], isBackstage)
      .catch(error => {
        const isAuthorizationExpired = error.code === ERROR_UNAUTHORIZED

        if (!isAuthorizationExpired) {
          throw error
        }

        return authenticate(() => {}, isBackstage, true)
          .then(() => authenticatedRequest(onUnexpectedError, operation, parameters, expectedErrors, isBackstage))
      })
}

export default useRequest
